import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { CommonService } from 'src-adisco/services/common.service';
import { ComparatorRepository } from 'src-adisco/repositories/comparator.repository';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { getPriceLevelLabel } from 'src-adisco/utils/getPriceLevelLabel';
import { UserService } from 'src/app/admin/core/services/user.service';

interface UrlFile {

  nameFile: string;
  nameFileDetail: string;
  urlFile: string;
  imgURL?: string;
}
@Component({
  selector: 'app-general-info',
  templateUrl: './general-info.component.html',
  styleUrls: ['./general-info.component.css'],
  providers: [MessageService, ConfirmationService],
})
export class GeneralInfoComponent {
  @Input() item: any;
  code!: string;
  dataSupplier!: any;
 
  @Input()  listUrlImageProduct: UrlFile[] = [];
  listIdTariff: any[] = [];
  priceCurrent: any;
  comparatorItemList: any[] = [];
  listImage: any[] = [
    {
      url: 'src-adisco/assets/images/product-big.png'
    },
    {
      url: 'src-adisco/assets/images/Produit-Biocide.png'
    },
    {
      url: 'src-adisco/assets/images/news.png'
    },
  ];
  imgShow = 'src-adisco/assets/images/image-default.jpeg';
  roleUser = localStorage.getItem('role');
  public role = {
    Partner : '[Extranet - Adhérent]',
    Commercial : '[Extranet - Commercial]',
    Supplier : '[Extranet - Fournisseur]',
    AdminGeolane : '[Administrateur Géolane]',
    AdminAdisco : '[Administrateur Adisco]',
    UserNoTarif : '[Extranet - Commercial sans tarif]'
}

  ngOnInit() {
    this.comparatorRepository.comparatorItemList$.subscribe((value) => {
      this.comparatorItemList = value;
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    this.code = this.item?.nameSupplier[0]?.value;
    if (this.code) {
      this.getSupplier(this.code);
    }
    // if (this.item?.supplierItemNumber) {
    //   this.getListImage(this.item?.supplierItemNumber)
    // }
    if (this.item?.linkToTariff && this.item?.linkToTariff[0]) {
      this.item?.linkToTariff.forEach((item: any) => {
        this.listIdTariff.push(item?.documentId);
      });
      this.getTariff(this.listIdTariff)
    }

    if(this.item?.mediumPhoto?.length > 0){
      this.imgShow = this.item?.mediumPhoto?.[0]?.url
    } else{
      this.imgShow = 'src-adisco/assets/images/image-default.jpeg'
    }
  }
  constructor(
    private dynamicDocumentService: DynamicDocumentService,
    private _cdf: ChangeDetectorRef,
    private _commonService: CommonService,
    private comparatorRepository: ComparatorRepository,
    private _messageService: MessageService,
    public userService: UserService
  ) {

  }
  getSupplier(code: string): void {
    this.dynamicDocumentService.find({
      collectionName: 'dynamic_legal_entity',
      filters: [
        {
          "fieldName": "code",
          "conditions": [
            {
              "type": "EQUALS",
              "value": code
            }
          ]
        }
      ],
      page: 1,
      pageSize: 150
    })
      .subscribe((res: any) => {
        this.dataSupplier = res?.content[0];
      });
  }
  // getListImage(value: any): void {
  //   this.dynamicDocumentService
  //     .find({
  //       "collectionName": "dynamic_ressource",
  //       "filters": [
  //         {
  //           "fieldName": "linkToProduct",
  //           "conditions": [
  //             {
  //               "type": "EQUALS",
  //               "value": value,
  //               "minValue": "",
  //               "maxValue": ""
  //             }
  //           ]
  //         }
  //       ],
  //       "sorts": {},
  //       "page": 1,
  //       "pageSize": 25
  //     })
  //     .subscribe((res: any) => {
  //       this.listUrlImageProduct = [];
  //       const dataListImage = res.content;
  //       if (dataListImage && dataListImage.length > 0) {
  //         const matchingItemsPhoto = dataListImage.filter((item: any) => {
  //           return item.typeOfResource && item.typeOfResource.value === "PHOTO" && item.file?.length > 0;
  //         });
  //         if (matchingItemsPhoto.length > 0) {
  //           matchingItemsPhoto.forEach((item: any) => {
  //             this.listUrlImageProduct.push({ urlImage: item?.file[0]?.url });
  //           });
  //           /* this.imgShow = this.listUrlImageProduct[0]?.urlImage; */
  //         }
  //         /* else {
  //           this.imgShow = 'src-adisco/assets/images/image-default.jpeg';
  //         } */
  //       }
  //     });
  // }
  showImage(img: any): void {
    this.imgShow = img;
  }
  sendClick(event: any): void {
    this._commonService.sendClickEvent(event);
  }
  addProductToCompare(id?: string): void {
    // if(localStorage.getItem('surname')) {
    //   this.comparatorRepository.getMyComparators().subscribe((_res) => {
    //   });
    // }
    // this._commonService.sendClickProduct(data);
    let listProductCompare = JSON.parse(localStorage.getItem('compare') as any);
    if (listProductCompare?.length > 4) {
      this._messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Maximum 5 produits',
        life: 3000,
      });
      return;
    }
    if (!id) return;
    this.comparatorRepository.addProduct([id]);
  }
  getTariff(ids: any[]): void {
    this._commonService.getDataTariff(ids).subscribe({
      next: (res) => {
        const data = res.response;
        const filteredData = data.filter((item: any) => item?.year && item?.year?.value === "N");
        if (filteredData.length > 0) {
          const latestItem = filteredData.reduce((prev: any, current: any) => {
            return (prev.price > current.price) ? prev : current;
          });

          this.priceCurrent = { ...latestItem, priceLevelLabel: getPriceLevelLabel(latestItem?.priceLevel?.value) };
        }
      },
      error: (error) => { },
    });
  };

  checkProductExitsCart(event: MouseEvent,item:any ) {
    const element = event.currentTarget as HTMLElement;
    if (this.hasExistProductToCard([item.id])) {
        element.classList.add('exit-product-cart');
    }else{
        element.classList.remove('exit-product-cart')
    }
}

hasExistProductToCard(productIds:any){
    return this.comparatorRepository.currentComparator?.obj?.linkToProduct?.some((p: any) =>
        productIds.includes(p.documentId))
}

}
